import {
  ApprovalStatus,
  CreateTimeInLieuInput,
  TimeInLieu,
} from "../../../API";
import { User } from "../../../hooks";
import { toAWSDate } from "../../../lib";
import { TimeOffEnum } from "../../../lib/types/absences";

type ExistingTimeInLieuProps = {
  timeInLieus?: TimeInLieu[] | null;
  existingTimeInLieuId?: string | null;
  formDateTaken?: string | null;
};

const validTimeInLieu: string[] = [
  TimeOffEnum.Approved,
  TimeOffEnum.Pending,
  TimeOffEnum.Expired,
];

export const checkExistingTimeInLieu = ({
  timeInLieus,
  existingTimeInLieuId,
  formDateTaken,
}: ExistingTimeInLieuProps) => {
  if (!timeInLieus || timeInLieus.length === 0) return false;

  return !!timeInLieus?.find((a) => {
    // If Updating current Absence ignore
    if (a.id === existingTimeInLieuId || !formDateTaken) return false;

    const dateTaken = a.dateTaken;

    const newDateTaken = toAWSDate(new Date(formDateTaken)) as string;

    const isValidRequest = validTimeInLieu.includes(a?.approvalStatus ?? "");

    return (
      // check if starts before and end is within the existing range
      newDateTaken === dateTaken && isValidRequest
    );
  });
};

export type TimeInLieuFormFields = CreateTimeInLieuInput;

export const mapDefaultValues = (
  value?: TimeInLieuFormFields,
  user?: User,
  employeeID?: string
): CreateTimeInLieuInput => ({
  id: value?.id,
  dateTaken: value?.dateTaken ?? "",
  hoursTaken: value?.hoursTaken ?? 0,
  dateEarned: value?.dateEarned ?? "",
  description: value?.description ?? "",
  employeeID: value?.employeeID ?? employeeID ?? user?.id ?? "",
  approvalStatus: value?.approvalStatus ?? ApprovalStatus.pending,
  approvedByClient: value?.approvedByClient ?? false,
});
